import React, { Fragment, Component } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import BrandForm from "./components/form";
import BrandTable from "./components/table";
import BrandCategoryService from "../../services/brandCategoryService";

import DateRangePicker from "../../components/common/dateRangePicker";
import Search from "../../components/common/search";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import $ from "jquery";
// import store from "store";

class CreateBrand extends Component {
  state = {
    infoData: [],
    page: 0,
    pageSize: 10,
    totalRecords: 0,
    loading: false,
  };
  componentWillMount() {
    console.log("-----DataTableComponent---");
    // this.setState({ infoData: data });
    // this.setState({ trainings: store.get("myCart") });
    // BrandCategoryService .fetchDetectedInfo().then(response => {
    //   // //console.log("response", response[0] === "{");
    //   toast.success("List fetched successfully!");
    //   // if (response[0] === "{") {
    //   //   this.setState({ infoData: [JSON.parse(response)] });
    //   // } else if (response[0] === "[") {
    //   //   this.setState({ infoData: JSON.parse(response) });
    //   // } else {
    //   //   this.setState({ infoData: [] });
    //   // }
    // });
  }

  componentWillMount() {
    const { match } = this.props;
    const { params } = match;
    const { brandStatus } = params;
    this.setState({ loader: true, brandStatus }, function () {
      this.callApiInfo();
    });
  }

  componentDidUpdate() {
    const { match } = this.props;
    const { params } = match;
    const { brandStatus } = params;
    if (this.state.brandStatus !== brandStatus) {
      this.setState(
        {
          loader: true,
          infoData: [],
          searchText: "",
          page: 0,
          pageSize: 10,
          totalRecords: 0,
          startDate: "",
          endDate: "",
          brandStatus: brandStatus,
        },
        function () {
          this.callApiInfo();
        }
      );
    }
  }

  callApiInfo = () => {
    const {
      brandStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate,
    } = this.state;
    BrandCategoryService.fetchBrandsInfo(
      undefined,
      brandStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate
    ).then((response) => {
      if (!response.error) {
        var totalRecords = Math.ceil(response?.data?.totalRecords / pageSize);
        console.log({ response: response.data });
        this.setState({
          modalFormShow: false,
          loader: false,
          infoData: response?.data?.brands,
          totalRecords: totalRecords,
        });
      } else {
        this.setState({
          loader: false,
          infoData: [],
          totalRecords: 0,
        });
      }
    });
    this.setState({ loader: false });
  };

  addBrandForm = (data) => {
    const { isEdit, info, imageUrl } = this.state;
    this.setState({ loader: true });
    data["imageUrl"] = imageUrl;
    data["brandId"] = isEdit ? info._id : undefined;
    var method = isEdit ? "PUT" : "POST";
    BrandCategoryService.addBrandInfo(data, method).then((response) => {
      if (!response.error) {
        this.callApiInfo();
        // this.props.history.push("/dealer/inbox");
      }
      // //console.log("response", response[0] === "{");
      // toast.success("List fetched successfully!");
      // if (response[0] === "{") {
      //   this.setState({ infoData: [JSON.parse(response)] });
      // } else if (response[0] === "[") {
      //   this.setState({ infoData: JSON.parse(response) });
      // } else {
      //   this.setState({ infoData: [] });
      // }
    });
  };

  onClickToggle = () => {
    this.setState({ modalFormShow: false });
  };

  onSearchText = (searchText) => {
    this.setState(
      {
        page: 0,
        searchText: searchText,
        startDate: "",
        endDate: "",
      },
      function () {
        if (searchText && searchText !== "" && searchText.length > 0) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };

  onSearchDate = (startDate, endDate) => {
    this.setState(
      {
        page: 0,
        searchText: "",
        startDate: startDate,
        endDate: endDate,
      },
      function () {
        if (startDate && endDate) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };

  onChangePageSize = (pageSize) => {
    this.setState(
      {
        pageSize: pageSize,
      },
      function () {
        if (pageSize) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };

  onChangePage = (page) => {
    this.setState(
      {
        page: page,
      },
      function () {
        $.ajaxQ.abortAll();
        this.callApiInfo();
      }
    );
  };

  onChangeImage = (imageUrl) => {
    this.setState({ imageUrl: imageUrl });
  };

  removeImage = () => {
    this.setState({ imageUrl: undefined });
  };

  onChangeUrl = (name, url) => {
    if ((name && name !== "") || (url && url !== "")) {
      console.log({ url });
      var { info, urlEdit } = this.state;
      var stringUrl = "";
      var urlEdit1 = false;
      if (name && !urlEdit) {
        stringUrl = name.toLowerCase();
      } else if (url) {
        stringUrl = url.toLowerCase();
        urlEdit1 = true;
      }
      stringUrl = stringUrl.replace(/ /g, "_");
      stringUrl = stringUrl.replace(/,/g, "_");
      stringUrl = stringUrl.replace(/__/g, "_");
      if (info) {
        info["sUrl"] = stringUrl;
      } else {
        info = { sUrl: stringUrl };
      }
      this.setState({ info: info, urlEdit: urlEdit1 });
    }
  };

  onChangeActive = (brandId, value, index) => {
    console.log({ brandId, value });
    const { infoData } = this.state;
    this.setState({ loader: true });
    BrandCategoryService.onBrandReady(brandId, value).then((response) => {
      if (!response.error) {
        infoData[index].public = value;
        this.setState({ infoData, loader: false });
        // this.props.history.push("/products/all");
      }
      this.setState({ loader: false });
    });
  };

  render() {
    const {
      brandStatus,
      infoData,
      modalFormShow,
      loader,
      info,
      index,
      isEdit,
      imageUrl,
    } = this.state;
    const { loading, page, pageSize, totalRecords } = this.state;
    // const propsDaterangePicker = {
    //   changeRangePicker: (startDate, endDate) => {
    //     //console.log({ startDate });
    //     //console.log({ endDate });
    //   }
    // };
    const brandFormProps = {
      info: info || {},
      active: this.state.active,
      imageUrl: imageUrl,
      onChangeImage: this.onChangeImage,
      removeImage: this.removeImage,
      onChangeUrl: this.onChangeUrl,
      searchProductUrl: "",
      searchUrlStatus: false,
      isEdit: this.state.isEdit,
      onChangeBrandId: (id) => {
        console.log({ id });
      },
      onClickConfirm: (data) => {
        //console.log(data)
        this.addBrandForm(data);
      },
      onClickActive: (active) => {
        this.setState({ active });
      },
      // BrandForm: infoData,
    };
    const propsTable = {
      brandStatus: brandStatus,
      multiSelectOption: false,
      myData: infoData,
      loading: loading,
      pageSize: pageSize,
      page: page,
      totalRecords: totalRecords,
      // pageSize: infoData.length < 10 ? infoData.length : 10,
      pagination: true,
      onChangeActive: this.onChangeActive,
      onEditBrandInfo: (index, info) => {
        this.props.history.push("/brands/" + info._id + "/update");
        // this.setState({
        //   modalFormShow: true,
        //   isEdit: true,
        //   info,
        //   imageUrl: info.imageUrl,
        // });
      },
      onChangePageSize: (pageSize) => {
        //console.log({ pageSize });
        this.onChangePageSize(pageSize);
      },
      onChangePage: (page) => {
        this.onChangePage(page);
      },
      deactivateMember: (staffMemberId) => {
        this.memberDeactivate(staffMemberId);
      },
      handleInfoEdit: (info) => {
        //console.log({info})
        this.dealerInfoEdit(info);
      },
    };
    // const propsSearchText = {
    //   searchText: this.state.searchText,
    //   onChangeText: (searchText) => {
    //     this.onSearchText(searchText);
    //   },
    // };
    return (
      <Fragment>
        <Breadcrumb title={brandStatus} parent="Brand" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card border-0" style={{boxShadow:"1px 5px 24px 0 rgba(68, 102, 242, .05)"}}>
                {/* <div className="card-header">
                  <h5>Select Multiple Data</h5>
                </div> */}

                {loader && (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      right: "45%",
                      zIndex: "+999",
                    }}
                  >
                    <div className="loader bg-white">
                      <div className="whirly-loader"> </div>
                    </div>
                  </div>
                )}
                <div className="card-body datatable-react" style={{padding:"30px"}}>
                  <div className="row mb-2">
                    <div className="col-sm-4">
                      <Button
                        className="btn btn-danger"
                        onClick={
                          () => this.props.history.push("/brands/add")
                          // this.setState({
                          //   modalFormShow: true,
                          //   isEdit: false,
                          //   info: undefined,
                          // })
                        }
                      >
                        Add New Brand
                      </Button>{" "}
                    </div>
                    <div className="col-sm-4">
                      {/* <Search {...propsSearchText} /> */}
                    </div>

                    <div className="col-sm-4" style={{ marginTop: "10px" }}>
                      {/* <DateRangePicker {...propsDaterangePicker} /> */}
                    </div>
                  </div>
                  {/* {infoData && infoData.length > 0 && ( */}
                  <BrandTable {...propsTable} className="-striped -highlight" />
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={modalFormShow}
          toggle={() => this.onClickToggle()}
          size="lg"
        // style={{ width: "80%", maxWidth: "90%" }}
        >
          <ModalHeader toggle={() => this.onClickToggle()}>
            {isEdit ? "Update brand info" : "Add Brand"}
          </ModalHeader>
          <ModalBody>
            <BrandForm {...brandFormProps} />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default CreateBrand;
